import { ReactNode } from 'react';

import Typography from '@components/atoms/Typography';
import SVGComponent from 'types/SVGComponent';

import classes from './Proposal.module.scss';

export type Props = {
  title: ReactNode;
  subtitle: ReactNode;
  icon: SVGComponent;
};

const Proposal = ({ icon: Icon, subtitle, title }: Props): JSX.Element => (
  <section className={classes.wrapper}>
    <Icon width={48} height={48} />
    <Typography variant="h1" renderAs="div" className={classes.title}>
      {title}
    </Typography>
    <Typography variant="h2" renderAs="div">
      {subtitle}
    </Typography>
  </section>
);

export default Proposal;
